import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import HistoryItem from './Items/HistoryItem';

const RecentSearches = ({ items, onSelect, inputValue }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);

  useEffect(() => {
    setSelectedIndex(-1);
  }, [inputValue]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (items.length === 0) return;

      if (event.key === 'ArrowDown') {
        setSelectedIndex((prevIndex) => (prevIndex + 1) % items.length);
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        setSelectedIndex((prevIndex) => (prevIndex === -1 || prevIndex === 0 ? items.length - 1 : prevIndex - 1));
        event.preventDefault();
      } else if (event.key === 'Enter' && selectedIndex >= 0) {
        onSelect(items[selectedIndex]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [items, selectedIndex, onSelect]);

  return (
    <>
      <Box px={4} py={2}>
        <Typography variant="subtitle2" color="grey.700" fontSize={14} fontWeight="bold">
          Recent Searches
        </Typography>
      </Box>
      {items.map((item, index) => (
        <HistoryItem
          key={index}
          item={item}
          onSelect={() => {
            onSelect(item);
          }}
          isSelected={index === selectedIndex}
        />
      ))}
    </>
  );
};

export default RecentSearches;
